var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { strategy as ethReceivedStrategy } from '../eth-received';
export var author = 'mccallofthewild';
export var version = '0.1.0';
var ethCharities = [
    ['GiveDirectly', '0xc7464dbcA260A8faF033460622B23467Df5AEA42'],
    ['Unsung.org', '0x02a13ED1805624738Cc129370Fee358ea487B0C6'],
    ['Heifer.org', '0xD3F81260a44A1df7A7269CF66Abd9c7e4f8CdcD1'],
    ['GraceAid.org.uk', '0x236dAA98f115caa9991A3894ae387CDc13eaaD1B'],
    ['SENS.org', '0x542EFf118023cfF2821b24156a507a513Fe93539'],
    ['350.org', '0x50990F09d4f0cb864b8e046e7edC749dE410916b'],
    ['EFF.org', '0xb189f76323678E094D4996d182A792E52369c005'],
    ['WikiLeaks', '0xE96E2181F6166A37EA4C04F6E6E2bD672D72Acc1'],
    ['GiveWell.org', '0x7cF2eBb5Ca55A8bd671A020F8BDbAF07f60F26C1'],
    ['CoolEarth.org', '0x3c8cB169281196737c493AfFA8F49a9d823bB9c5'],
    ['Run2Rescue.org', '0xd17bcbFa6De9E3741aa43Ed32e64696F6a9FA996'],
    ['Archive.org', '0xFA8E3920daF271daB92Be9B87d9998DDd94FEF08']
];
export function strategy() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return __awaiter(this, void 0, void 0, function () {
        var space, network, provider, addresses, options, snapshot, _a, coeff;
        return __generator(this, function (_b) {
            space = args[0], network = args[1], provider = args[2], addresses = args[3], options = args[4], snapshot = args[5];
            _a = options.coeff, coeff = _a === void 0 ? 100 : _a;
            return [2 /*return*/, ethReceivedStrategy(space, network, provider, addresses, {
                    receivingAddresses: ethCharities.map(function (_a) {
                        var name = _a[0], address = _a[1];
                        return address;
                    }),
                    coeff: coeff
                }, snapshot)];
        });
    });
}
